const flags = {
    'nl-BE': '🇧🇪',
    'fr-BE': '🇫🇷',
    'en-GB': '🇬🇧',
    en_GB: '🇬🇧',
};

export default {
    languageCodeToEmoji(code) {
        return flags[code] || '❓';
    },
};
